import { envSchema } from '../env';

const env = envSchema.parse(import.meta.env);

export { env };
